<template>
  <v-app-bar app clipped-left color="primary" dark flat height="68" class="app-toolbar">
    <v-app-bar-nav-icon
      v-if="currentUser.userType !== 'teacher'"
      aria-label="Open navigation"
      class="toolbar-icon"
      @click.stop="drawerToggle"
    />

    <button class="brand" type="button" aria-label="Go to dashboard" @click="navigateToHome">
      <span class="brand-mark"><v-icon color="primary" size="22">mdi-book-open-page-variant-outline</v-icon></span>
      <span v-if="!$vuetify.breakpoint.xsOnly" class="brand-copy">
        <span class="business-name">{{ currentBusiness.name }}</span>
        <span class="product-name">Taleem administration</span>
      </span>
      <span v-else class="mobile-business-name">{{ mobileBusinessName }}</span>
    </button>

    <div v-if="$vuetify.breakpoint.mdAndUp" class="desktop-search">
      <GlobalSearch />
    </div>

    <v-spacer />

    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      icon
      class="toolbar-icon mr-1"
      aria-label="Search"
      @click="openSearchBox = true"
    >
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

    <UserMenu />

    <v-dialog v-model="openSearchBox" fullscreen transition="dialog-bottom-transition">
      <v-card color="#F7F9F7" tile>
        <v-toolbar color="primary" dark flat>
          <v-btn icon aria-label="Close search" @click="openSearchBox = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title class="mobile-search-title">Search Taleem</v-toolbar-title>
        </v-toolbar>
        <div class="mobile-search-panel">
          <div class="mobile-search-copy">Find a parent, donor, student, or application</div>
          <GlobalSearch autofocus @searched="openSearchBox = false" />
        </div>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GlobalSearch from "@/modules/Layout/components/GlobalSearch.vue";
import UserMenu from "./Menu";

export default {
  name: "app-toolbar",
  components: { GlobalSearch, UserMenu },
  data() {
    return { openSearchBox: false };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness", "currentUser"]),
    mobileBusinessName() {
      const name = (this.currentBusiness && this.currentBusiness.name) || "Taleem";
      return name.length > 24 ? `${name.slice(0, 22)}…` : name;
    },
  },
  methods: {
    ...mapActions("layout", ["drawerToggle"]),
    navigateToHome() {
      this.$router.push("/").catch(err => {
        if (err.name !== "NavigationDuplicated") console.error(err);
      });
    },
  },
};
</script>

<style scoped>
.app-toolbar { border-bottom: 1px solid rgba(0, 0, 0, .08) !important; }
.toolbar-icon { color: rgba(255, 255, 255, .92) !important; }
.brand { display: flex; align-items: center; min-width: 230px; max-width: 310px; padding: 0; margin: 0 28px 0 8px; color: white; border: 0; background: transparent; text-align: left; cursor: pointer; }
.brand-mark { display: flex; align-items: center; justify-content: center; flex: 0 0 38px; width: 38px; height: 38px; margin-right: 11px; border-radius: 10px; background: white; }
.brand-copy { display: flex; min-width: 0; flex-direction: column; }
.business-name { overflow: hidden; color: white; font-size: 15px; font-weight: 650; line-height: 1.2; text-overflow: ellipsis; white-space: nowrap; }
.product-name { color: rgba(255, 255, 255, .72); font-size: 11px; line-height: 1.4; }
.desktop-search { width: min(620px, 45vw); }
.mobile-business-name { overflow: hidden; color: white; font-size: 15px; font-weight: 650; text-overflow: ellipsis; white-space: nowrap; }
.mobile-search-panel { max-width: 680px; margin: 0 auto; padding: 28px 20px; }
.mobile-search-copy { margin-bottom: 12px; color: #64748b; font-size: 13px; }
.mobile-search-title { font-size: 17px; }
@media (max-width: 959px) {
  .brand { min-width: 0; max-width: calc(100vw - 165px); margin-right: 8px; }
}
@media (max-width: 599px) {
  .app-toolbar ::v-deep .v-toolbar__content { padding: 0 8px; }
  .brand { max-width: calc(100vw - 158px); margin-left: 3px; }
  .brand-mark { display: none; }
}
</style>
